const elf = document.querySelector('[data-christmas-elf]');
if (elf && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
  // Keep fixed positioning outside page-transition containers and their transforms.
  document.body.append(elf);
  const hero = document.querySelector('#MainContent [id$="__section_P8jrtk"]')
    ?? document.querySelector('#MainContent .hero');
  const appearances = { hero: 0, viewport: 0 };
  let nextAppearance = Date.now() + 1500;
  let visible = false;
  let location = 'hero';
  let lastLocation = 'viewport';
  let hideTimer;
  const heroVisible = () => {
    if (!hero) return false;
    const rect = hero.getBoundingClientRect();
    return rect.bottom > 160 && rect.bottom < window.innerHeight - 20;
  };
  const position = () => {
    const bottom = location === 'hero' && hero ? window.innerHeight - hero.getBoundingClientRect().bottom + 30 : 0;
    elf.style.bottom = `${Math.max(0, bottom)}px`;
  };
  const hide = () => {
    clearTimeout(hideTimer);
    elf.classList.remove('is-visible');
    visible = false;
    nextAppearance = Date.now() + 12000;
  };
  const show = () => {
    if (visible) {
      if (location === 'hero' && !heroVisible()) hide();
      else position();
      return;
    }
    if (document.hidden || Date.now() < nextAppearance) return;
    const canHero = appearances.hero < 4 && heroVisible();
    const canViewport = appearances.viewport < (hero ? 4 : 8);
    if (!canHero && !canViewport) return;
    location = canHero && (lastLocation !== 'hero' || !canViewport) ? 'hero' : 'viewport';
    if (location === 'viewport' && !canViewport) return;
    appearances[location] += 1;
    lastLocation = location;
    visible = true;
    position();
    elf.classList.add('is-visible');
    hideTimer = setTimeout(hide, 4000);
  };
  window.addEventListener('scroll', show, { passive: true });
  window.addEventListener('resize', () => { if (visible) position(); }, { passive: true });
  window.addEventListener('pointermove', (event) => {
    if (event.pointerType !== 'mouse') return;
    show();
    if (visible) elf.style.setProperty('--elf-tilt', `${(event.clientX / window.innerWidth - .5) * 12}deg`);
  }, { passive: true });
  document.addEventListener('visibilitychange', () => { if (document.hidden) hide(); });
}
